import {Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faArrowDownToBracket, faArrowUpFromBracket, faCircleInfo} from '@fortawesome/pro-solid-svg-icons';
import {BicButtonComponent, BicPopupComponent} from '@buildinginformationcloud/bic-ui-components';

@Component({
  selector: 'app-ki-rule-import-popup',
  standalone: true,
  imports: [FaIconComponent, BicButtonComponent, BicPopupComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ki-rule-import-popup.component.html',
})
export class KiRuleImportPopupComponent {
  @Input() importing = false;
  /** Beim Import ALLE bestehenden Prüfregeln des Regelsets löschen und durch die Datei ersetzen. */
  @Input() replaceExisting = false;
  @Output() closed = new EventEmitter<void>();
  @Output() downloadTemplate = new EventEmitter<void>();
  @Output() fileSelected = new EventEmitter<File>();
  @Output() replaceExistingChange = new EventEmitter<boolean>();
  @ViewChild('fileInput') fileInput?: ElementRef<HTMLInputElement>;

  protected readonly faArrowDownToBracket = faArrowDownToBracket;
  protected readonly faArrowUpFromBracket = faArrowUpFromBracket;
  protected readonly faCircleInfo = faCircleInfo;

  triggerFilePicker(): void {
    this.fileInput?.nativeElement.click();
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (file) this.fileSelected.emit(file);
  }
}
